"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIntl = void 0;
const intl_1 = require("@formatjs/intl");
const injection_key_1 = require("./injection-key");
const createIntl = (options) => ({
    install(app) {
        if (!options) {
            throw new Error('Missing `options` for vue-intl plugin');
        }
        const intl = (0, intl_1.createIntl)(options);
        app.config.globalProperties.$intl = intl;
        app.config.globalProperties.$formatMessage = intl.formatMessage;
        app.config.globalProperties.$formatDate = intl.formatDate;
        app.config.globalProperties.$formatTime = intl.formatTime;
        app.config.globalProperties.$formatDateTimeRange = intl.formatDateTimeRange;
        app.config.globalProperties.$formatRelativeTime = intl.formatRelativeTime;
        app.config.globalProperties.$formatDisplayName = intl.formatDisplayName;
        app.config.globalProperties.$formatNumber = intl.formatNumber;
        app.config.globalProperties.$formatList = intl.formatList;
        app.provide(injection_key_1.intlKey, intl);
    },
});
exports.createIntl = createIntl;
